module.exports = __webpack_public_path__ + "img/Favicon.83613966.png";